import {Api} from "laravel-request";
import {clearChatId} from "#app/api/middleware/websocketConnector";
import {makeRequest} from "#app/pages/Cabinet/components/Chat/ChatRequests";

import {CallbackOptions, SortIdCases} from "#app/api/types";
import {mapToTaskContactDTO, TaskContactDTO} from "#app/api/dto/contactDTO";

export const buildFetchItemsQuery = (clientId: string|number, isArchive: boolean|string|number, sortId: SortIdCases ) => {
    let query = Api.get('client', 'index')
        .with('financeGroups')
        .with('financeGroups.unionUser')
        .with('oppositeFinanceGroup')
        .with('atonUsers')
        .with('mainContact', (q) => {
            return q.with('refuseReason').with('tasks', (tq) => tq.orderBy('end_at', 'DESC'));
        });

    query.whereHas('mainContact', (q) => q.where('is_archive', '=', isArchive ? 1 : 0));

    if (sortId) {
        switch (sortId) {
            case 1:
                query.orderBy('users.created_at', 'DESC');
                break;
            case 2:
                query.orderBy('users.created_at', 'ASC');
                break;
            case 3:
                query.orderBy('users.last_name', 'DESC');
                break;
            case 4:
                query.orderBy('users.last_name', 'ASC');
                break;
            case 5:
                // query.orderBy('last_activity', 'DESC');
                break;
            case 6:
                // query.orderBy('last_activity', 'ASC');
                break;
            case 7:
            case 8:
                break;
            default:
                break;
        }
    } else {
        query.orderBy('created_at', 'DESC');
    }

    if (clientId) {
        query.where('id', '=', clientId);
    }

    return query;
}

export const callbackOnFetchItemsSuccess = ({ response, userData, actions }: CallbackOptions): void => {
    const { appendLastMessages, sortItems, setLoading } = actions;

    let preparedResponseData = [...(response.data || [])];
    let phones: Array<ReturnType<typeof clearChatId>> = [];
    preparedResponseData.forEach((client) => {
        if (client?.mainContact?.phone) {
            phones.push(clearChatId(client.mainContact.phone));
        }
    });

    makeRequest({
        url: 'chat/last',
        data: { phones },
        userId: userData?.id,
        callback: (data: any): void => {
            preparedResponseData = appendLastMessages(data, preparedResponseData);
            sortItems(preparedResponseData);
            setLoading(false);
        },
        errorCallback: () => {
            sortItems(preparedResponseData);
            setLoading(false);
        },
    });
};

export const getTaskClients = (
    userId: string | number,
    stateCallback: any
) => {
    Api.get('client', 'index')
        .where('manager_id', userId)
        .all((responseClients) => {
            Api.get('crm-contact', 'index')
                .where('user_id', userId)
                .all((responseContacts) => {
                    const newContacts: TaskContactDTO[] = [
                        ...mapToTaskContactDTO(responseClients.data, 'user'),
                        ...mapToTaskContactDTO(responseContacts.data, 'contact'),
                    ];

                    stateCallback(newContacts)
                });
        });
}